module.exports = __webpack_public_path__ + "media/shipment/shipment_store-976bc198.svg";